{
  "name": "admin",
  "private": true,
  "version": "2.4.3",
  "type": "module",
  "scripts": {
    "dev": "vite --host",
    "build": "vite build",
    "typecheck": "tsc --noEmit",
    "prod": "vite build --mode production",
    "stage": "vite build --mode stage",
    "staging": "vite build --mode staging",
    "lint": "eslint . --ext ts,tsx --report-unused-disable-directives --max-warnings 0",
    "preview": "vite preview"
  },
  "dependencies": {
    "@entrecode/statsapp-components": "^0.0.52",
    "@heroicons/react": "^2.2.0",
    "@radix-ui/react-tooltip": "^1.2.12",
    "@resvg/resvg-wasm": "^2.6.2",
    "@sentry/react": "^10.65.0",
    "@sentry/vite-plugin": "^5.4.0",
    "@tailwindcss/forms": "^0.5.11",
    "@types/node": "^26.1.1",
    "@types/react-date-range": "^1.4.10",
    "@uidotdev/usehooks": "^2.4.1",
    "auto-text-size": "^0.2.3",
    "chart.js": "^4.5.1",
    "chartjs-plugin-style": "^0.5.0",
    "dayjs": "^1.11.21",
    "ec.fdk": "^0.8.9",
    "framer-motion": "^10.18.0",
    "html-to-image": "^1.11.13",
    "modern-screenshot": "^4.7.0",
    "oidc-client-ts": "^2.5.0",
    "oidc-react": "^3.4.1",
    "react": "^18.3.1",
    "react-chartjs-2": "^5.3.1",
    "react-date-range": "^1.4.0",
    "react-day-picker": "^9.14.0",
    "react-dom": "^18.3.1",
    "react-helmet": "^6.1.0",
    "react-helmet-async": "^2.0.5",
    "react-loading-skeleton": "^3.5.0",
    "react-oidc-context": "^2.4.0",
    "react-router": "^7.18.1",
    "swr": "^2.4.2"
  },
  "devDependencies": {
    "@types/react": "^18.3.31",
    "@types/react-dom": "^18.3.7",
    "@typescript-eslint/eslint-plugin": "^6.21.0",
    "@typescript-eslint/parser": "^6.21.0",
    "@vitejs/plugin-react": "^6.0.3",
    "autoprefixer": "^10.5.2",
    "eslint": "^8.57.1",
    "eslint-plugin-react-hooks": "^4.6.2",
    "eslint-plugin-react-refresh": "^0.4.26",
    "postcss": "^8.5.18",
    "tailwindcss": "^3.4.19",
    "typescript": "^5.9.3",
    "vite": "^8.1.4",
    "vite-plugin-mkcert": "^2.1.0"
  }
}
